import { wceApi } from '@/api';

let designEditorCache: GetDesignEditorResponse | null = null;

type GetDesignEditorResponse = {
  adminUrl: string;
  clientApi: string;
  clientId: string;
  mallNo: number;
  readyshopConfig: {
    agreeCPA: string | null;
    agreeCPAYmdt: string | null;
    appKeys: {
      android?: string;
      NAVER?: string;
    } | null;
    appSecrets: {
      android?: string;
      NAVER?: string;
    } | null;
    bankdaExpirationYmdt: string | null;
    companyInfoLinkAddress: string | null;
    enabledBankda: boolean | null;
    enableOtp: boolean | null;
    enableSale: boolean | null;
    favicon: string | null;
    fontFamily: string | null;
    googleAnalytics: string | null;
    instagramAccessToken: string | null;
    instagramExpiredYmdt: string | null;
    kakaoMapKey: string | null;
    kakaoMapLatitude: number | null;
    kakaoMapLongitude: string | null;
    logoId: string | null;
    logoText: string | null;
    logoType: string | null;
    logoUrl: string | null;
    mallDescription: string | null;
    mallDns: string | null;
    managerBirthDay: string | null;
    managerName: string | null;
    mobileLogoId: string | null;
    mobileLogoUrl: string | null;
    naverCommonAuthKey: string | null;
    naverMallGradeType: string | null;
    naverShoppingUseYn: string | null;
    naverWebmaster: string | null;
    notifyInstagramExpired: boolean | null;
    objectStoragePath: string | null;
    otpSecret: string | null;
    paycoCallbackDomain: string | null;
    representativeImageHeight: number | null;
    representativeImageUrl: string | null;
    representativeImageWidth: number | null;
    sealImageUrl: string | null;
    serviceCode: string | null;
    showDefaultTemplateSelector: boolean | null;
    showEasyTemplateSelector: boolean | null;
    showTutorial: boolean | null;
    templateType: string | null;
    useScript: boolean | null;
  } | null;
};

export const getCachedDesignEditor = (cb: (res: GetDesignEditorResponse) => void) => {
  if (designEditorCache) {
    cb(designEditorCache);
  } else {
    wceApi.get<GetDesignEditorResponse>('/design/editor')
      .then(({ data }) => {
        designEditorCache = data;
        cb(data);
      });
  }
};

export const fetchPolicyShopinfo = (cb: (res: { terms: string; personalInfo: string }) => void) => {
  getCachedDesignEditor(({ readyshopConfig: { mallDns } }) => {
    cb({
      terms: `http://${mallDns}/common/agreement.html`,
      personalInfo: `http://${mallDns}/common/privacy.html`,
    });
  });
};
